import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/",
    },
    {
      path: "/",
      name: "PageView",
      component: (resolve) => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home",
        },
        {
          path: "/home",
          name: "home",
          component: (resolve) => require(["@/view/HomePage/HomePage"], resolve),
          meta: {
            title: "首页",
          },
        },
        {
          path: "/service",
          name: "service",
          component: (resolve) => require(["@/view/Service/Service"], resolve),
          meta: {
            title: "相关服务",
          },
        },
        {
          path: "/area",
          name: "area",
          component: (resolve) => require(["@/view/Area/Area"], resolve),
          meta: {
            title: "业务领域",
          },
        },
        {
          path: "/customer",
          name: "customer",
          component: (resolve) => require(["@/view/Customer/Customer"], resolve),
          meta: {
            title: "业务领域",
          },
        },
        {
          path: "/companyteam",
          name: "companyteam",
          component: (resolve) =>
            require(["@/view/CompanyTeam"], resolve),
          meta: {
            title: "专业团队",
          },
        },
        {
          path: "/contactus",
          name: "contactus",
          component: (resolve) => require(["@/view/ContactUs"], resolve),
          meta: {
            title: "联系我们",
          },
        },
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js